export enum OperationStatusType {
  /** Заключено */
  Concluded = 'Concluded',
  /** Отменено */
  Cancelled = 'Cancelled',
}
